/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaseListLoadDto } from './CaseListLoadDto';
import {
    CaseListLoadDtoFromJSON,
    CaseListLoadDtoFromJSONTyped,
    CaseListLoadDtoToJSON,
    CaseListLoadDtoToJSONTyped,
} from './CaseListLoadDto';
import type { AdmissionSoakDto } from './AdmissionSoakDto';
import {
    AdmissionSoakDtoFromJSON,
    AdmissionSoakDtoFromJSONTyped,
    AdmissionSoakDtoToJSON,
    AdmissionSoakDtoToJSONTyped,
} from './AdmissionSoakDto';
import type { WorkflowStartSoakDto } from './WorkflowStartSoakDto';
import {
    WorkflowStartSoakDtoFromJSON,
    WorkflowStartSoakDtoFromJSONTyped,
    WorkflowStartSoakDtoToJSON,
    WorkflowStartSoakDtoToJSONTyped,
} from './WorkflowStartSoakDto';
import type { BacklogDrainDto } from './BacklogDrainDto';
import {
    BacklogDrainDtoFromJSON,
    BacklogDrainDtoFromJSONTyped,
    BacklogDrainDtoToJSON,
    BacklogDrainDtoToJSONTyped,
} from './BacklogDrainDto';
import type { IngestScaleSnapshotDto } from './IngestScaleSnapshotDto';
import {
    IngestScaleSnapshotDtoFromJSON,
    IngestScaleSnapshotDtoFromJSONTyped,
    IngestScaleSnapshotDtoToJSON,
    IngestScaleSnapshotDtoToJSONTyped,
} from './IngestScaleSnapshotDto';
import type { SloCheckDto } from './SloCheckDto';
import {
    SloCheckDtoFromJSON,
    SloCheckDtoFromJSONTyped,
    SloCheckDtoToJSON,
    SloCheckDtoToJSONTyped,
} from './SloCheckDto';

/**
 * 
 * @export
 * @interface IngestScaleSloReportDto
 */
export interface IngestScaleSloReportDto {
    /**
     * 
     * @type {Date}
     * @memberof IngestScaleSloReportDto
     */
    generatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof IngestScaleSloReportDto
     */
    milestone?: string;
    /**
     * 
     * @type {IngestScaleSnapshotDto}
     * @memberof IngestScaleSloReportDto
     */
    snapshot?: IngestScaleSnapshotDto;
    /**
     * 
     * @type {Array<SloCheckDto>}
     * @memberof IngestScaleSloReportDto
     */
    checks?: Array<SloCheckDto>;
    /**
     * 
     * @type {boolean}
     * @memberof IngestScaleSloReportDto
     */
    overallPassed?: boolean;
    /**
     * 
     * @type {AdmissionSoakDto}
     * @memberof IngestScaleSloReportDto
     */
    admissionSoak?: AdmissionSoakDto;
    /**
     * 
     * @type {WorkflowStartSoakDto}
     * @memberof IngestScaleSloReportDto
     */
    workflowStartSoak?: WorkflowStartSoakDto;
    /**
     * 
     * @type {BacklogDrainDto}
     * @memberof IngestScaleSloReportDto
     */
    backlogDrain?: BacklogDrainDto;
    /**
     * 
     * @type {CaseListLoadDto}
     * @memberof IngestScaleSloReportDto
     */
    caseListLoad?: CaseListLoadDto;
}

/**
 * Check if a given object implements the IngestScaleSloReportDto interface.
 */
export function instanceOfIngestScaleSloReportDto(value: object): value is IngestScaleSloReportDto {
    return true;
}

export function IngestScaleSloReportDtoFromJSON(json: any): IngestScaleSloReportDto {
    return IngestScaleSloReportDtoFromJSONTyped(json, false);
}

export function IngestScaleSloReportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IngestScaleSloReportDto {
    if (json == null) {
        return json;
    }
    return {
        
        'generatedAt': json['generatedAt'] == null ? undefined : (new Date(json['generatedAt'])),
        'milestone': json['milestone'] == null ? undefined : json['milestone'],
        'snapshot': json['snapshot'] == null ? undefined : IngestScaleSnapshotDtoFromJSON(json['snapshot']),
        'checks': json['checks'] == null ? undefined : ((json['checks'] as Array<any>).map(SloCheckDtoFromJSON)),
        'overallPassed': json['overallPassed'] == null ? undefined : json['overallPassed'],
        'admissionSoak': json['admissionSoak'] == null ? undefined : AdmissionSoakDtoFromJSON(json['admissionSoak']),
        'workflowStartSoak': json['workflowStartSoak'] == null ? undefined : WorkflowStartSoakDtoFromJSON(json['workflowStartSoak']),
        'backlogDrain': json['backlogDrain'] == null ? undefined : BacklogDrainDtoFromJSON(json['backlogDrain']),
        'caseListLoad': json['caseListLoad'] == null ? undefined : CaseListLoadDtoFromJSON(json['caseListLoad']),
    };
}

export function IngestScaleSloReportDtoToJSON(json: any): IngestScaleSloReportDto {
    return IngestScaleSloReportDtoToJSONTyped(json, false);
}

export function IngestScaleSloReportDtoToJSONTyped(value?: IngestScaleSloReportDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'generatedAt': value['generatedAt'] == null ? undefined : ((value['generatedAt']).toISOString()),
        'milestone': value['milestone'],
        'snapshot': IngestScaleSnapshotDtoToJSON(value['snapshot']),
        'checks': value['checks'] == null ? undefined : ((value['checks'] as Array<any>).map(SloCheckDtoToJSON)),
        'overallPassed': value['overallPassed'],
        'admissionSoak': AdmissionSoakDtoToJSON(value['admissionSoak']),
        'workflowStartSoak': WorkflowStartSoakDtoToJSON(value['workflowStartSoak']),
        'backlogDrain': BacklogDrainDtoToJSON(value['backlogDrain']),
        'caseListLoad': CaseListLoadDtoToJSON(value['caseListLoad']),
    };
}

